export const FILTERS_UPDATES_SUBSCRIPTION = `
  subscription FiltersUpdates {
    filtersUpdates(input: { segment: CB }) {
      projects {
        code
        name
      }
    }
  }
`;

export interface FiltersUpdatesPayload {
  filtersUpdates?: {
    projects?: Array<{ code?: string | null; name?: string | null } | null> | null;
  } | null;
}
